import { ExpansionPendingBanner } from "@/ui/common/components/Activity/components/ExpansionPendingBanner";
import { StakeExpansionSection } from "@/ui/common/components/Activity/components/StakeExpansionSection";
import { DelegationWithFP } from "@/ui/common/types/delegationsV2";

import { ActivityCardActionSection } from "./components/ActivityCardActionSection";
import { ActivityCardAmountSection } from "./components/ActivityCardAmountSection";
import { ActivityCardDetailsSection } from "./components/ActivityCardDetailsSection";

export interface ActivityCardDetailItem {
  label: string;
  value: string | React.ReactNode;
}

export interface ActivityListItemData {
  icon?: string | React.ReactNode;
  iconAlt?: string;
  name: string;
  id?: string;
}

export interface ActivityCardActionButton {
  label: string;
  onClick: () => void;
  variant?: "contained" | "outlined";
  size?: "small" | "medium" | "large";
  className?: string;
  fullWidth?: boolean;
  disabled?: boolean;
}

export interface ActivityCardData {
  formattedAmount: string;
  icon?: string | React.ReactNode;
  iconAlt?: string;
  details: ActivityCardDetailItem[];
  optionalDetails?: ActivityCardDetailItem[];
  listItems?: {
    label: string;
    items: ActivityListItemData[];
  }[];
  groupedDetails?: {
    label?: string;
    items: ActivityCardDetailItem[];
  }[];
  primaryAction?: ActivityCardActionButton;
  secondaryActions?: ActivityCardActionButton[];
  expansionSection?: DelegationWithFP;
  isPendingExpansion?: boolean;
  showExpansionPendingBanner?: boolean;
}

interface ActivityCardProps {
  data: ActivityCardData;
  className?: string;
}

export function ActivityCard({ data, className }: ActivityCardProps) {
  return (
    <div
      className={`w-full space-y-3 rounded bg-secondary-highlight p-3 sm:space-y-4 sm:p-4 ${className || ""}`}
    >
      <ActivityCardAmountSection
        formattedAmount={data.formattedAmount}
        icon={data.icon}
        iconAlt={data.iconAlt}
        primaryAction={data.primaryAction}
      />
      <ActivityCardDetailsSection
        details={data.details}
        optionalDetails={data.optionalDetails}
        listItems={data.listItems}
        groupedDetails={data.groupedDetails}
      />
      {data.showExpansionPendingBanner && <ExpansionPendingBanner />}
      {data.expansionSection && (
        <StakeExpansionSection
          delegation={data.expansionSection}
          isPendingExpansion={data.isPendingExpansion}
        />
      )}
      {data.secondaryActions && data.secondaryActions.length > 0 && (
        <ActivityCardActionSection actions={data.secondaryActions} />
      )}
    </div>
  );
}
